export const DESCRIPTION =
  'We match parts of podcast episodes to relevant topics across the web.';
export const SITE_NAME = 'Headliner';
export const TITLE = 'Easy podcast discovery';
export const OG_TYPE = 'music.radio_station';
export const TWITTER_CARD_TYPE = 'summary_large_image';
export const TWITTER_HANDLE = '@HeadlinerVideo';
